import { IconSpinner } from "@/assets/icons/geist/IconSpinner";
import { Input } from "@/components/podkit/forms/Input";
import { Search } from "lucide-react";
import type { FC, InputHTMLAttributes } from "react";

type ProjectSearchInputProps = {
    searchValue?: string;
    isLoading?: boolean;
    disabled?: boolean;
    setSearchValue: (value: string) => void;
} & InputHTMLAttributes<HTMLInputElement>;
export const ProjectSearchInput: FC<ProjectSearchInputProps> = ({
    searchValue,
    isLoading,
    disabled,
    setSearchValue,
    ...props
}) => {
    return (
        <label className="relative flex w-full">
            <span className="sr-only">Search projects</span>

            <Search className="absolute left-[12px] top-[11px] z-10 text-content-tertiary" size={14} />
            {isLoading && <IconSpinner className="absolute right-[12px] top-[10px] z-10 text-content-tertiary animate-spin" size="sm" />}
            <Input
                placeholder="Search projects"
                className="w-full max-w-none pl-8 "
                value={searchValue || ""}
                onChange={(e) => setSearchValue(e.target.value.trimStart().replace(/\s+/g, " "))}
                disabled={disabled}
                {...props}
            />
        </label>
    );
};
